// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator bookkeepers`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* companies manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 47 cases in this module */,
    [employees, {}] /* Referenced by 47 cases in this module */,
    [features, {}] /* Referenced by 21 cases in this module */,
    [
      legalEntities,
      {
        bookkeeper_view: true,
      },
    ] /* Referenced by 122 cases in this module */,
    [payrollPolicies, {}] /* Referenced by 6 cases in this module */,
    [policyPeriods, {}] /* Referenced by 4 cases in this module */,
    [users, {}] /* Referenced by 36 cases in this module */,
  ] /* Generated file 👉 artifacts/bookkeepers-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
